export function Disconnectivity() {
    return (
        <div className="modal fade show d-block" style={{backgroundColor: 'rgba(0,0,0,0.5)'}} tabIndex="-1">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content text-center">
                    <div className="modal-header border-0">
                        <h5 className="modal-title text-primary fw-bold w-100">Looks like there is a connectivity issue. Please try refreshing the bot again, after reconnecting to the internet.</h5>
                    </div>
                </div>
            </div>
        </div>
    );
}